<template lang="pug">
  app-dialog(v-model="$_show" header="Документ на основе шаблона" confirm-text="Создать" :confirm-disabled="isNotReady" @confirm="createDocument")
    template(slot="prepend")
      v-tabs.ma-0(v-model="tab" background-color="#F0F0F0" color="#00BCD4" slider-color="#00BCD4" height="42" light centered grow)
        v-tab.text-none Компьютер
        v-tab.text-none Шаблоны
        v-tab.text-none ГАС

    .document
      v-tabs-items(v-model="tab" light)
        v-tab-item(light)
          .local
            v-btn.mx-0(@click="$refs.localfile.click()") Выберите файл
              v-icon(right dark) attach_file
            app-card-caption.mb-6 {{ form.originalName }}
            input(type="file" style="display: none" ref="localfile" :accept="acceptFormats" @change="onFilePicked")

        v-tab-item(light)
          .template 
            app-select(
              v-model="form.selectedTagId" 
              :items="docTemplateTags" 
              label="Тег" 
              item-text="name" item-value="id" 
              no-data-text="Тегов не найдено" 
              clearable
              persistent-hint hint="Вы можете выбрать тег, чтобы отфильтровать список шаблонов"
            )
            app-select(
              v-model="form.selectedTemplate" 
              :items="availableTemplates" 
              label="Шаблон" 
              item-text="name" 
              return-object 
              no-data-text="Шаблонов не найдено" 
              @input="onTemplateSelected"
            )
        v-tab-item(light)
          app-select(
              v-model="form.base64" 
              :items="docsGas" 
              label="Документ" 
              item-text="name" 
              return-object 
              no-data-text="Документов не найдено" 
              @input="onDocumentSelected"
            )

      app-text-field(v-model="form.name" label="Имя документа")
      
      app-select.mt-6(
        v-model="form.selectedMembers" 
        :items="members" 
        item-text="displayName" 
        item-value="id" 
        label="Получатели" 
        persistent-hint hint="Выберите одного или нескольких получателей"
        multiple  
        clearable clear-icon="delete"
        chips deletable-chips
      )
        template(v-slot:prepend-item)
          v-list-item(ripple @click="toggleAll")
            v-list-item-action
              v-icon {{ checkboxIcon }}
            v-list-item-content
              v-list-item-title Все участники дела
          v-divider.mt-2
        
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AppDialogToggable } from '@/components'
import { docService } from "@/_services"

export default {
  mixins: [AppDialogToggable],

  props: {
    member: null
  },
  
  data () {
    const defaultForm = Object.freeze({
      selectedTagId: null,
      selectedTemplate: null,
      originalName: '',
      name: '',
      selectedMembers: [],
      base64: null
    })

    return {
      form: Object.assign({}, defaultForm),
      defaultForm,
      tab: 0
    }
  },

  watch: {
    $_show (value) {
      if (value) {
        this.form = Object.assign({}, this.defaultForm)
        this.form.selectedMembers = this.member ? [this.member.id] : []
      }
    }
  },

  computed: {
    ...mapGetters('courtCase', ['currentSession', 'members', 'docTemplates', 'docTemplateTags', 'docsGas']),

    acceptFormats () {
      let types = [
        'application/msword',
        'application/pdf',
        'text/plain',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
      ]
      return types.join(', ')
    },

    availableTemplates () {
      return this.form.selectedTagId
      ? this.docTemplates.filter(item => item.tagged.findIndex(x => x.myTag.id == this.form.selectedTagId) != -1)
      : this.docTemplates.slice()
    },

    isAllMembers () {
      return this.form.selectedMembers.length === this.members.length
    },

    isSomeMembers () {
      return this.form.selectedMembers.length > 0 && !this.isAllMembers
    },

    checkboxIcon () {
      if (this.isAllMembers) return 'check_box'
      if (this.isSomeMembers) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },

    isNotReady () {
      if (this.tab == 0 && (this.form.originalName.length == 0 || this.form.name.length == 0)) return true
      if (this.tab == 1 && (!this.form.selectedTemplate || this.form.name.length == 0)) return true
      if (this.tab == 2 && (!this.form.base64 || this.form.name.length == 0)) return true
      return this.form.selectedMembers.length == 0
    }
  },

  methods: {
    ...mapActions('courtCase', ['createSubpoena', 'createDocumentByTemplate', 'createDocumentFromLocalFile']),

    createDocument () {
      if (this.tab == 0) {
        this.uploadFile()
      }
      else if (this.tab == 1) {
        this.createDocumentByTemplate({ 
          members: this.form.selectedMembers, 
          template: this.form.selectedTemplate, 
          name: this.form.name
        })
      }
      else if (this.tab == 2) {
        let obj = this
        this.base64ToFile('data:application/msword;base64,' + this.form.base64.text, 'document.docx', 'application/msword')
          .then(function(file) { 
              let formData = new FormData();
              formData.append("file", file)
              docService.uploadRfiles(formData)
              .then(fileName => obj.createDocumentFromLocalFile({
                members: obj.form.selectedMembers, 
                name: obj.form.name, 
                file: fileName
              }))
           });
      }
    },

    uploadFile () {
      let formData = new FormData();
      formData.append("file", this.$refs.localfile.files[0])

      docService.uploadRfiles(formData)
      .then(fileName => this.createDocumentFromLocalFile({
        members: this.form.selectedMembers, 
        name: this.form.name, 
        file: fileName
      }))
    },

    toggleAll () {
      this.$nextTick(() => {
        this.form.selectedMembers = this.isAllMembers ? [] : this.members.slice()
      })
    },

    onFilePicked (e) {
			const files = e.target.files
			if (files[0] !== undefined) {
        this.form.originalName = files[0].name
				this.form.name = files[0].name
			}
    },

    onTemplateSelected () {
      this.form.name = this.form.selectedTemplate.name
    },

    onDocumentSelected () {
      this.form.name = this.form.base64.name
    },

    base64ToFile(url, filename, mimeType){
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename,{type:mimeType});})
        )
    }
  }
}
</script>

<style scoped>
.document {
  padding: 16px 0px;
}
.subpoena__time {
  width: 160px;
  display: inline-block;
}
</style>
